/* eslint-disable @typescript-eslint/no-explicit-any */ import { getStories, getStoryBySlug } from "@cinch-nx/data-storyblok";
import { tagError, traceFunction } from "@core/datadog-server";
const instrumentedGetStoryBySlug = traceFunction("getStoryBySlug", getStoryBySlug);
const instrumentedGetStories = traceFunction("getStories", getStories);
export function getStaticPropsGenerator({ subHubPath , resultsPerPage =10 , breadCrumbs =[] , generatePageBreadcrumb =false  }) {
    return async ({ preview =false , params  })=>{
        const version = preview ? "draft" : "published";
        const localBreadcrumbs = [
            ...breadCrumbs
        ];
        let currentPage = 1;
        try {
            if (typeof (params === null || params === void 0 ? void 0 : params.page) === "string") {
                if ((params === null || params === void 0 ? void 0 : params.page) === "1") {
                    // Redirect [sub-hub]/page/1 to [sub-hub]/
                    return {
                        redirect: {
                            permanent: true,
                            destination: `/${subHubPath}`
                        }
                    };
                } else {
                    currentPage = Number.parseInt(params.page);
                }
            }
            const [subHubStory, { articles , total: numberOfArticles  }] = await Promise.all([
                getSubHubStory({
                    subHubPath,
                    version
                }),
                getArticlesForPage({
                    subHubPath,
                    version,
                    perPage: resultsPerPage,
                    page: currentPage
                })
            ]);
            subHubStory.content.title = subHubStory.content.title || breadCrumbs[breadCrumbs.length - 1].text;
            if (generatePageBreadcrumb && currentPage !== 1) {
                localBreadcrumbs.push({
                    text: `Page ${currentPage}`,
                    url: `/${subHubPath}/page/${currentPage}`
                });
            }
            return {
                props: {
                    preview,
                    story: subHubStory,
                    path: subHubPath,
                    currentPage,
                    numberOfArticles,
                    resultsPerPage,
                    articles,
                    layoutProps: {
                        showBorderRadius: true,
                        breadCrumbs: localBreadcrumbs
                    },
                    generatedAt: Date.now()
                },
                revalidate: 60
            };
        } catch (error) {
            console.log(error);
            if (typeof error === "string" || error instanceof Error) {
                tagError(error);
            }
            return {
                notFound: true,
                revalidate: 60
            };
        }
    };
}
function toArticle(subhubPath) {
    return (input)=>({
            path: `/${subhubPath}/${input.slug}`,
            title: input.content.title,
            image: input.content.image,
            date: input.published_at ?? ""
        });
}
async function getSubHubStory({ subHubPath , version  }) {
    const story = await instrumentedGetStoryBySlug(`articles/hubs/${subHubPath}`, {
        version
    });
    if (!story || !story.content || story.content.component !== "ArticlesSubHubPage") {
        throw new Error(`Failed to load story for sub-hub ${subHubPath}`);
    }
    return story;
}
async function getArticlesForPage({ subHubPath , version , page , perPage  }) {
    const articleStories = await instrumentedGetStories({
        version,
        starts_with: `articles/${subHubPath}`,
        page,
        per_page: perPage,
        sort_by: "published_at:desc"
    }).catch(()=>({
            stories: [],
            total: 0
        }));
    if (articleStories.stories.length === 0) {
        throw new Error(`no articles available for "articles/${subHubPath}" page ${page}`);
    }
    return {
        articles: articleStories.stories.map(toArticle(subHubPath)),
        total: Number(articleStories.total)
    };
}
